import { Box } from "@mui/material";
import React from "react";

export const AnimatedBackground = () => {
  return (
    <Box component="div" className="area">
      <ul className="circles">
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
    </Box>
  );
};
